import {
  faEnvelope,
  faEye,
  faPencil,
  faPlus,
  faTrash,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { AgGridReact } from 'ag-grid-react'
import { useEffect, useState } from 'react'
import { Card, CardBody } from 'reactstrap'
import CreateJobOnboarding from './CreateJobOnboarding'
import { useDispatch } from 'react-redux'
import { getOnboardJobs } from 'store/Recruitment/actions'
import { useSelector } from 'react-redux'
import moment from 'moment'
import { setAreYouSureModalData } from 'store/Recruitment/actions'
import { deleteOnboardingJob } from 'store/Recruitment/actions'
import AddToJobOnboard from '../JobDetails/ApplicationDetails/AddToJobOnboard'
import { setFormSubmitted } from 'store/Recruitment/actions'
import OfferLetterModal from './OfferLetterModal'

const getStatusColor = (status) => {
  switch (status) {
    case 'pending':
      return 'bg-warning text-white'
    case 'cancel':
      return 'btn-danger'
    case 'confirm':
      return 'btn-success'
    default:
      return 'btn-info'
  }
}

function JobOnboarding() {
  const dispatch = useDispatch()
  const { onboardingJobs } = useSelector((store) => store.recruitment)

  const [showModal, setShowModal] = useState()
  const [showOfferLetterModal, setShowOfferLetterModal] = useState(false)

  const [applicationId, setApplicationId] = useState(null)
  const [jobOnboard, setJobOnboard] = useState(null)

  const columns = [
    {
      headerName: 'No',
      field: 'no',
      valueGetter: (params) => params.node.rowIndex + 1,
    },
    { headerName: 'Name', field: 'name', sortable: true, unSortIcon: true },
    { headerName: 'Job', field: 'title', sortable: true, unSortIcon: true },
    {
      headerName: 'Type',
      field: 'recruitment_type',
      cellRenderer: (params) => (
        <span className='text-capitalize'>{params.value}</span>
      ),
      sortable: true,
      unSortIcon: true,
    },
    { headerName: 'Branch', field: 'branch' },
    {
      headerName: 'Location',
      field: 'location',
      sortable: true,
      unSortIcon: true,
    },
    {
      headerName: 'Applied At',
      field: 'applied_at',
      cellRenderer: (params) =>
        params.value ? moment(params.value).format('DD-MM-YYYY') : '',
      sortable: true,
      unSortIcon: true,
    },
    {
      headerName: 'Joining At',
      field: 'joining_date',
      cellRenderer: (params) =>
        params.value ? moment(params.value).format('DD-MM-YYYY') : '',
      sortable: true,
      unSortIcon: true,
    },
    {
      headerName: 'Status',
      field: 'status',
      sortable: true,
      unSortIcon: true,
      cellRenderer: (params) => (
        <button
          className={`text-capitalize btn py-1 ${getStatusColor(params.value)}`}
        >
          {params.value}
        </button>
      ),
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
      },
    },
    {
      headerName: 'Action',
      field: 'action',
      cellRenderer: (params) => (
        <div className='d-flex align-items-center' style={{ gap: '1rem' }}>
          <FontAwesomeIcon
            size='lg'
            icon={faEnvelope}
            title='View Offer Letter'
            role='button'
            className='text-warning'
            onClick={() => {
              setShowOfferLetterModal(true)
              setJobOnboard(params.data)
              setApplicationId(params.data.application_id)
            }}
          />
          <FontAwesomeIcon
            size='lg'
            icon={faPencil}
            title='Edit'
            role='button'
            className='text-info'
            onClick={() => {
              setApplicationId(params.data.application_id)
              setJobOnboard(params.data)
              setShowModal(true)
            }}
          />
          <FontAwesomeIcon
            size='lg'
            icon={faTrash}
            title='Delete'
            role='button'
            className='text-danger'
            onClick={() =>
              dispatch(
                setAreYouSureModalData({
                  show: true,
                  text: `Application's job stage will reset to the default one.`,
                  customFn: () => dispatch(deleteOnboardingJob(params.data.id)),
                })
              )
            }
          />
        </div>
      ),
      flex: 1,
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
      },
    },
  ]

  const defaultColDef = {
    sortable: true,
    unSortIcon: false,
    suppressMenu: true,
    flex: 1,
    minWidth: 100,
    resizable: true,
  }

  useEffect(() => {
    dispatch(getOnboardJobs())
  }, [dispatch])

  useEffect(() => {
    if (!showModal) {
      dispatch(setFormSubmitted(false))
    }
  }, [dispatch, showModal])

  useEffect(() => {
    if (!showModal && !showOfferLetterModal) {
      setJobOnboard(null)
    }
  }, [showModal, showOfferLetterModal])

  return (
    <>
      <Card
        onClick={() => setShowModal(true)}
        className='bg-info text-white plus-button'
      >
        <FontAwesomeIcon icon={faPlus} className='' />
      </Card>
      <Card>
        <CardBody>
          <div
            className='ag-theme-alpine'
            style={{ height: '600px', width: '100%' }}
          >
            <AgGridReact
              columnDefs={columns}
              rowData={onboardingJobs}
              defaultColDef={defaultColDef}
            />
          </div>
        </CardBody>
      </Card>
      {showModal && (
        <AddToJobOnboard
          showModal={showModal}
          setShowModal={setShowModal}
          applicationId={applicationId}
          jobOnboard={jobOnboard}
        />
      )}
      {showOfferLetterModal && (
        <OfferLetterModal
          showModal={showOfferLetterModal}
          setShowModal={setShowOfferLetterModal}
          applicationId={applicationId}
          jobOnboard={jobOnboard}
        />
      )}
    </>
  )
}

export default JobOnboarding
